import dayjs from 'dayjs';
import { BoardStats } from '../types/task';

// Turns the numbers the API sends for a board's statistics into what the statistics screen shows. Pure, so it can be
// tested without a screen.

// part / whole as a whole percentage; null when there is no whole (nothing came due, so there is no rate).
export const percent = (part: number, whole: number): number | null =>
    whole === 0 ? null : Math.round((part / whole) * 100);

// One entry per calendar day from the start of the range to its end, including the days nothing was completed
// (the API only reports days with completions).
export function completionsPerDay(stats: Pick<BoardStats, 'range' | 'perDay'>): { day: string, count: number }[] {
    const counts = new Map(stats.perDay.map((row) => [row.day, row.count]));
    const first = dayjs(stats.range.from).startOf('day');
    const last = dayjs(stats.range.to).startOf('day');

    const days: { day: string, count: number }[] = [];
    for (let d = first; !d.isAfter(last, 'day'); d = d.add(1, 'day')) {
        const day = d.format('YYYY-MM-DD');
        days.push({ day, count: counts.get(day) ?? 0 });
    }

    return days;
}
